import { getApiOrigin, resolvePublicAssetUrl } from "@maeiz/core";

/**
 * Uploaded files (profile pictures, product images, logos) come back as absolute URLs built from
 * whatever address the server was configured with when the file was saved. Anything served from the
 * server's own `/storage` or `/uploads` folders is re-pointed at the API origin the app talks to,
 * so an image keeps working when that address changes (a new host, a phone on the LAN…).
 */
export function assetUrl(path?: string | null): string | undefined {
    if (!path) return undefined;
    const match = /^https?:\/\/[^/]+(\/(?:storage|uploads)\/.*)$/i.exec(path.trim());
    if (match) return `${getApiOrigin()}${match[1]}`;
    return resolvePublicAssetUrl(path);
}
